import {

  UploadOutlined,
  EyeOutlined,
  DeleteOutlined,
  FileImageOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import {
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Typography,
  Upload,
  Button,
  theme,
  message,
  List,
  Tag,
  Modal,
  Card,
  Skeleton,
  AutoComplete,
} from "antd";
import { Content } from "antd/es/layout/layout";
import React, { useEffect, useState } from "react";
import Heading from "../../../../../components/common/heading";
import TableNameList from "../create/table";
import "../../style.css";
import { MultipleAutoComplete } from "../../../../../components/common/autoCompleteV2";
import { ThaiDatePicker } from "../../../../../components/common/thaiDatePicker";

const { useToken } = theme;

const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;


const FutureDetail = (props,


) => {
  const {
    onUploadFile,
    fileImageList,
    beforeUpload,
    onPreviewFile = () => { },
    onRemoveImageFile = () => { },
    onUploadImageFile,
    preview = { visible: false, src: "", isPdf: false, title: "" },
    setPreview,
    slotIndex,
    handleFavorite,
    items,
    thumbs,
    companyAutocomplete,
    getListCompany
  } = props
  const { token } = useToken();
  const [form] = Form.useForm();

  const [topicMag, setTopicMag] = useState(false);
  const onChangeTopic = (value) => {
    console.log("value", value)
    onChangeContactReason(value);
    let checkMag = value.find(
      (v) => v === "965a18a0-1029-410b-9900-1c1d1c1fea47"
    );

    if (checkMag) {
      setTopicMag(true);
    } else {
      setTopicMag(false);
    }
  };
  const handlePreviewClose = () => {
    // ปิดแบบคงค่าที่เหลือไว้ (กัน field อื่นหาย)
    setPreview(prev => ({ ...prev, visible: false }));
  };

  const {
    dropDownContactReason,
    getYearDropdown,
    dropDownAreaType,
    dropDownCompanyType,
    dropDownCurerntStatus,
    dropDownIndustryType,
    dropDownCountry,
    dropDownFutureEstate,
    dropDownRegionType,
    setValueRange,
    onChangesetYearOfBudget,
    onChangeContactReason,
    onChangeContactReasonOtherDetail,
    onChangeCurrentStatus,
    onDefaultChange,
    onChangeCompanyType,
    onChangeIndustryTypeIds,
    onChangeNationalIds,
    onChangeAreaTypeIds,
    countMonth,
    setCounthMonth,
    onCalculatorMonth,
    onChangeFutureEstate,
    onChangeRegionType,
    //TABLELIST
    dataSource,
    editingRow,
    handleAdd,
    handleEdit,
    onSaveTable,
    handleDeleteReccord,
    statusBT,
    tableAction,
    otherTopicDefined,
    records,
    setRecords,

  } = props;

  useEffect(() => {
    if (otherTopicDefined) {
      setTopicMag(true);
    } else {
      setTopicMag(false);
    }
  }, [otherTopicDefined]);

  return (
    <Content>
      <Row gutter={[8, 16]} className="card">
        <Col span={24}>
          <Heading
            text={"ข้อมูลลูกค้าอนาคต"}
            size={4}
            style={{ margin: 0, color: token.thPrimary }}
          />
          <Divider />
        </Col>
        <Col span={16}>
          <Form.Item
            label="เลขทะเบียนพาณิชย์ (DBD Register number) (กรอกเป็นตัวเลข 13 หลัก)"
            name={"dbdRegisterNumber"}
            rules={[
              {
                pattern: new RegExp(/([0-9])/g),
                message: "โปรดระบุ",
              },
            ]}
          >
            <Input
              placeholder="DBD Register number"
              maxLength={13}
            // style={{ width: "70%" }}
            />
          </Form.Item>
        </Col>

        <Col span={16}>
          <Form.Item
            label="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
            name={"topicList"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <Select
              mode="multiple"
              placeholder="ประเด็นติดต่อต่าง ๆ (ตอบได้มากกว่า 1 ข้อ)"
              onChange={onChangeTopic}
            >
              {dropDownContactReason.map((item) => (
                <Option key={item.dataId} value={item.dataId}>{item.dataDetailTh}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        {topicMag === true && (
          <Col className="gutter-row" span={16}>
            <Form.Item
              label=""
              name={"topicOther"}
              style={{ marginTop: 8 }}
            >
              <Input.TextArea placeholder="รายละเอียด (อื่นๆ)" />
            </Form.Item>
          </Col>
        )}

        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label="ปีงบประมาณ"
                name={"yearOfBudget"}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Select
                  allowClear
                  showSearch={false}
                  className="w-full"
                  placeholder="กรุณาเลือก"
                  optionFilterProp="children"
                  onChange={onChangesetYearOfBudget}
                  hasfeedback="true"
                >
                  {getYearDropdown?.map((option, i) => {
                    return (
                      <Option key={i} value={option.value}>
                        {option.label}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="วัน/เดือน/ปี ที่รับลูกค้า"
                name={"dateFromTo"}
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <ThaiDatePicker
                  onChange={(date, dateString) => {
                    onCalculatorMonth(date, dateString);
                    setValueRange(dateString);
                  }}
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label="สถานะปัจจุบัน"
                name={"currentStatus"}
                // rules={[
                //   {
                //     required: true,
                //     message: "โปรดระบุ",
                //   },
                // ]}
              >
                <Select
                  allowClear
                  showSearch={false}
                  className="w-full custom-current-status-select"
                  placeholder="กรุณาเลือก"
                  optionFilterProp="children"
                  // onChange={onChangeCurrentStatus}
                  hasfeedback="true"
                  disabled
                >
                  {dropDownCurerntStatus.map((option, i) => {
                    return (
                      <Option key={i} value={option.dataId}>
                        {option.dataDetailTh}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Lead Time" name={"lead_time"}>
                <Text>{countMonth || 0} เดือน</Text>
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={"วัตถุประสงค์ขอคำปรึกษาด้านการลงทุน"}
                name="isInvestmentAdvice"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio
                    value={true}
                    style={{ paddingRight: 30, marginBottom: 5 }}
                  >
                    <Text strong>ใช่</Text>
                  </Radio>
                  <Radio
                    value={false}
                    style={{ paddingRight: 30, marginBottom: 5 }}
                  >
                    <Text strong>ไม่ใช่</Text>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"วัตถุประสงค์เยี่ยมชมพื้นที่/สอบถามข้อมูลที่ดิน"}
                name="isVisitAreaLandInfo"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio
                    value={true}
                    style={{ paddingRight: 30, marginBottom: 5 }}
                  >
                    <Text strong>ใช่</Text>
                  </Radio>
                  <Radio
                    value={false}
                    style={{ paddingRight: 30, marginBottom: 5 }}
                  >
                    <Text strong>ไม่ใช่</Text>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"วัตถุประสงค์สอบถามอนุมัติ/อนุญาต"}
                name="isAskForApprove"
                rules={[
                  {
                    required: true,
                    message: "โปรดระบุ",
                  },
                ]}
              >
                <Radio.Group>
                  <Radio
                    value={true}
                    style={{ paddingRight: 30, marginBottom: 5 }}
                  >
                    <Text strong>ใช่</Text>
                  </Radio>
                  <Radio
                    value={false}
                    style={{ paddingRight: 30, marginBottom: 5 }}
                  >
                    <Text strong>ไม่ใช่</Text>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={16}>
          <Form.Item
            label="วัตถุประสงค์ในการติดต่ออื่นๆ (โปรดระบุ)"
            name={"otherPurposes"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="รายละเอียด"
              showCount
              maxLength={400}
            />
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label="ประเภทการจัดตั้งบริษัท"
            name={"companyType"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <Select
              allowClear
              showSearch={false}
              className="w-full"
              placeholder="กรุณาเลือก"
              optionFilterProp="children"
              onChange={onChangeCompanyType}
              hasfeedback="true"
            >
              {dropDownCompanyType.map((option, i) => {
                return (
                  <Option key={i} value={option.dataId}>
                    {option.dataDetailTh}
                  </Option>
                );
              })}
            </Select>
          </Form.Item>
        </Col>
        <Divider style={{ margin: 0 }} />

        <Col span={16}>
          <Form.Item
            label="ชื่อบริษัท (TH/EN)"
            name={"companyNameTh"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <AutoComplete
                filterOption={true}
                options={companyAutocomplete}
                onSearch={(text) => getListCompany(text)}
              >
                <Input placeholder="ชื่อบริษัท"/>
              </AutoComplete>
          </Form.Item>
        </Col>
        {/* <Col span={16}>
          <Form.Item
            label="ชื่อบริษัท (EN)"
            name={"companyNameEn"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <Input placeholder="ชื่อบริษัท (EN)"></Input>
          </Form.Item>
        </Col> */}
        <Col span={16}>
          <Form.Item label="ที่อยู่บริษัท" name={"address"}>
            <TextArea rows={4} placeholder="รายละเอียด" />
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item label="Website บริษัท" name={"website"}>
            <Input placeholder="Website บริษัท"></Input>
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label="สัญชาติบริษัท"
            name={"nationalIds"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <MultipleAutoComplete
              className="w-full"
              multiple={false}
              subject="countryOrderNameTh"
              valueField="countryId"
              labelField="countryNameTh"
              placeholder="กรุณาเลือก"
              onChange={onChangeNationalIds}
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <TableNameList
            dataSource={dataSource}
            setRecords= {setRecords}
            records = {records}
            editingRow={editingRow}
            handleAdd={handleAdd}
            handleEdit={handleEdit}
            handleFavorite = {handleFavorite}
            onSaveTable={onSaveTable}
            handleDeleteReccord={handleDeleteReccord}
            statusBT={statusBT}
            tableAction={tableAction}
          ></TableNameList>
        </Col>

        <Col span={16}>
          <Form.Item
            label="อุตสาหกรรมปัจจุบัน"
            name={"currentIndustry"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <TextArea rows={4} placeholder="รายละเอียด" />
          </Form.Item>
        </Col>
        <Col span={16}>
          <Form.Item
            label="อุตสาหกรรมที่ต้องการดำเนินการในพื้นที่ กนอ."
            name={"ieatIndusrty"}
            rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
          >
            <TextArea rows={4} placeholder="รายละเอียด" />
          </Form.Item>
        </Col>

        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label="ประเภทอุตสาหกรรม"
                name={"industryTypeIds"}
                rules={[
              {
                required: true,
                message: "โปรดระบุ",
              },
            ]}
              >
                <Select
                  allowClear
                  showSearch={false}
                  className="w-full"
                  placeholder="กรุณาเลือก"
                  optionFilterProp="children"
                  onChange={onChangeIndustryTypeIds}
                  hasfeedback="true"
                >
                  {dropDownIndustryType.map((option, i) => {
                    return (
                      <Option key={i} value={option.dataId}>
                        {option.dataDetailTh}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="เงินลงทุนธุรกิจ" name={"investmentAmount"}>
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="เช่น 100,000.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "investmentAmount")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={16}>
          <Row gutter={[8, 16]}>
            <Col span={12}>
              <Form.Item
                label="ประเภทพื้นที่ที่ลูกค้าต้องการ"
                name={"areaTypeIds"}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch={false}
                  className="w-full"
                  placeholder="กรุณาเลือก"
                  optionFilterProp="children"
                  onChange={onChangeAreaTypeIds}
                  hasfeedback="true"
                >
                  {dropDownAreaType.map((option, i) => {
                    return (
                      <Option key={i} value={option.dataId}>
                        {option.dataDetailTh}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="ประเภทอสังหาริมทรัพย์"
                name={"estateTypeIds"}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch={false}
                  className="w-full"
                  placeholder="กรุณาเลือก"
                  optionFilterProp="children"
                  onChange={onChangeFutureEstate}
                  hasfeedback="true"
                >
                  {dropDownFutureEstate.map((option, i) => {
                    return (
                      <Option key={i} value={option.dataId}>
                        {option.dataDetailTh}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={"ขนาดพื้นที่ที่ต้องการ (ไร่)"}
                name={"areaSizeRai"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "areaSizeRai")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"ขนาดพื้นที่ที่ต้องการ (งาน)"}
                name={"areaSizeNgan"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "areaSizeNgan")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"ขนาดพื้นที่ที่ต้องการ (วา)"}
                name={"areaSizeWa"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "areaSizeWa")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                label={"ขนาดโรงงานมาตรฐานที่ต้องการ (ตารางเมตร)"}
                name={"areaSizeMeter"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "areaSizeMeter")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"ปริมาณการใช้ไฟฟ้า (กิโลวัตต์)"}
                name={"kwAmount"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) => onDefaultChange(value, "kwAmount")}
                ></InputNumber>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"ภูมิภาคที่ลูกค้าสนใจลงทุน"}
                name={"regionTypeIds"}
                // name={"areaSizeRecommend"}
              >
                <Select
                  mode="multiple"
                  allowClear
                  showSearch={false}
                  className="w-full"
                  placeholder="กรุณาเลือก"
                  optionFilterProp="children"
                  onChange={onChangeRegionType}
                  hasfeedback="true"
                >
                  {dropDownRegionType.map((option, i) => {
                    return (
                      <Option key={i} value={option.dataId}>
                        {option.dataDetailTh}
                      </Option>
                    );
                  })}
                </Select>
                {/* <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "areaSizeRecommend")
                  }
                ></InputNumber> */}
              </Form.Item>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 16]}>
            <Col span={8}>
              <Form.Item
                  label={"ปริมาณการใช้น้ำประปา ลูกบาศก์เมตร/วัน (ลบ.ม./วัน)"}
                  name={"waterConsumptionAmount"}
                >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "waterConsumptionAmount")
                  }
                ></InputNumber>
              </Form.Item>
              
            </Col>
            <Col span={8}>
              <Form.Item
                label={"ปริมาณน้ำเสีย ลูกบาศก์เมตร/วัน (ลบ.ม./วัน)"}
                name={"wasteWaterAmount"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "wasteWaterAmount")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label={"ปริมาณการใช้น้ำดิบ ลูกบาศก์เมตร/วัน (ลบ.ม./วัน)"}
                name={"untreatedWaterAmount"}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  placeholder="0.00"
                  min={0}
                  max={9999999999.99}
                  maxLength={13}
                  step="0.01"
                  onChange={(value, type) =>
                    onDefaultChange(value, "untreatedWater")
                  }
                ></InputNumber>
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item
                label="แนบไฟล์ รูป ลูกค้าอนาคต "
                name={["filePath"]}
                rules={[{ required: false, message: "โปรดระบุ" }]}
              >
                <Upload
                  accept="image/jpg,image/jpeg,application/pdf"
                  multiple={true}
                  customRequest={(e) => onUploadImageFile(e, slotIndex)}       // ✅ index = 0
                  beforeUpload={(file) => {
                    const okType = ["image/jpeg", "image/jpg", "application/pdf"].includes(file.type);
                    if (!okType) {
                      message.error("รองรับไฟล์ JPG/JPEG และ PDF เท่านั้น");
                      return Upload.LIST_IGNORE;
                    }
                    const sizeOk = file.size / 1024 / 1024 <= 50;
                    if (!sizeOk) {
                      message.error("ขนาดไฟล์ต้องไม่เกิน 50 MB");
                      return Upload.LIST_IGNORE;
                    }
                    return true;
                  }}
                  onRemove={(info) => onRemoveImageFile(info, slotIndex)}           // ✅ ลบเฉพาะช่องนี้
                  // ✅ แสดงเฉพาะไฟล์ของ index นี้
                  fileList={(fileImageList || []).filter((x) => x.index === slotIndex)}
                  showUploadList={{ showDownloadIcon: false, showRemoveIcon: true }}
                >
                  {/* {(fileImageList || []).filter((x) => x.index === slotIndex).length < 1 && ( */}
                  <Button icon={<UploadOutlined />}>เลือกไฟล์</Button>
                  {/* )} */}
                </Upload>

                <span style={{ color: "#667085", fontSize: 13 }}>
                  สามารถ Upload File ได้ 1 File รองรับนามสกุล JPG, PDF ขนาดไม่เกิน 50 Mb
                </span>
              </Form.Item>
            </Col>

            {/* ====== แกลเลอรี (การ์ดกริด) ====== */}
            <Row gutter={[12, 12]}>
              {items.map((it) => {
                const th = thumbs[it.path];
                const isPdf = th?.isPdf || it.fileName?.toLowerCase().endsWith(".pdf");
                return (
                  <Col key={it.uid || it.path} xs={24} sm={12} md={8} lg={8} xl={6}>
                    <Card
                      hoverable
                      bodyStyle={{ padding: 8 }}
                      cover={
                        <div
                          style={{
                            width: "100%",
                            aspectRatio: "4/3",
                            overflow: "hidden",
                            background: "#f5f5f5",
                            borderRadius: 12,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                          }}
                          onClick={() => onPreviewFile(it.path)}
                        >
                          {isPdf ? (
                            <FilePdfOutlined style={{ fontSize: 48, color: "#9f1239" }} />
                          ) : th?.src ? (
                            <img
                              src={th.src}
                              alt={it.fileName}
                              style={{ maxWidth: "100%", maxHeight: "100%" }}
                            />
                          ) : (
                            <Skeleton.Image active style={{ width: "60%", height: "60%" }} />
                          )}

                          <Button
                            type="text"
                            icon={<EyeOutlined />}
                            style={{ position: "absolute", top: 8, right: 8 }}
                            onClick={(e) => { e.stopPropagation(); onPreviewFile(it.path); }}
                          />
                        </div>
                      }
                    >
                      <div style={{ fontSize: 12, color: "#666", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
                        {it.fileName}
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>

            {/* ====== Modal Preview (เต็มกว้าง, antd v5 ใช้ open) ====== */}
            <Modal
              open={!!preview.visible}
              title={preview.title}
              footer={null}
              onCancel={() => setPreview((p) => ({ ...p, visible: false }))}
              width="90vw"
              style={{ top: 24 }}
              bodyStyle={{ padding: 0 }}
              getContainer={() => document.body}
              zIndex={2000}
              destroyOnClose
            >
              <div style={{ padding: 16 }}>
                {preview.isPdf ? (
                  <iframe src={preview.src} title="pdf" style={{ width: "100%", height: "75vh", border: 0 }} />
                ) : (
                  <img src={preview.src} alt="" style={{ display: "block", maxWidth: "100%", maxHeight: "75vh", margin: "0 auto" }} />
                )}
              </div>
            </Modal>
          </Row>
        </Col>
      </Row>
    </Content>
  );
};

export default FutureDetail;
